import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { ServerConstantsService, DataService, DateUtility, CommonUtility,
         REPSTDT_GT_REPENDDT, REPSTDT_INTERVAL_REPENDDT, PyramidVO,
          EmploymentTrainingRetentionRequest} from '../shared';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { saveAs } from 'file-saver';
import * as jsPDF from 'jspdf';
import * as canvg from 'canvg';

@Component({
    selector: 'app-employment-training-retention',
    templateUrl: './employment-training-retention.component.html',
    styleUrls: ['./employment-training-retention.component.scss']
  })
  export class EmploymentTrainingRetentionComponent implements OnInit {
    chartData: any;

    ServerConstants: any;
    reportNames: any[];
    reportCounties: any[];
    reportProviders: any[];
    reportAreas: any[];
    reportParticipationTypes: any[];

    userActionNotificationsMap: any;
    report: any;
    reportCounty: any;
    reportProvider: any;
    reportAreaCode: any;
    reportNameOutput: any;
    reportParticipation: any;
    reportBeginDate: any;
    reportEndDate: any;

    errorEndDateField: any;
    errorMandatoryProvider: any;
    errorMandatoryCounty: any;

    sharedData: any;

    payloadEmploymentTrainingRetentionVO: PyramidVO;
    payloadEmploymentTrainingRetentionRequest: EmploymentTrainingRetentionRequest;
    roleId: number;
    butDisabled: boolean = false;
    countyDisabled: boolean = false;
    providerDisabled: boolean = false;
    areaDisabled: boolean = false;
    participationDisabled: boolean = false;
    countyArray: string[] = [];
    countyId: any;
    provider: any;
    countyCode: any;
    

    employmentRetentionInput: boolean = false;
    pdfDocument: boolean = false;
    loaderFocus: Boolean = false;
    loaderGenerateFocus: Boolean = false;
    componentActivityInput: boolean = false;

    reportSelectedParticipationName : string;
    reportSelectedCountyName : string;
    reportSelectedAreaName : string;
    reportSelectedProviderName : string;
    reportSelectedParticipantName : string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private dateUtil: DateUtility,
        private data: ReferenceTableService,
        private commonUtil: CommonUtility,
        private refTableService: ReferenceTableService,
        private notificationService: NotificationsService,
        public dataService: DataService,
        private serverConstantsService: ServerConstantsService
) {
    this.ServerConstants = serverConstantsService.getConstants();
}
    ngOnInit() {

        this.sharedData = this.dataService.getSharedDataObject();
        this.getReportNames();
        this.loadUserInformation();
        this.loadParticipationTypes();
        this.getUserActionNotifications();
              
        //Sets current report by default on dropdown.
        this.report = 'ET';

        if (this.sharedData.get("roles")[0].id == 5) {
          this.butDisabled = true;
        }
        else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
        {
          this.butDisabled = true;
          this.countyDisabled =  true;
        }

    }

    getReportNames() {
        let reports = this.refTableService.getValueFromSharedDataMap("REPORT_NAME");
        this.reportNames = [];
        for (let entry of reports) {
            this.reportNames.push(entry);
        }
    }

    loadUserInformation() {
      
      this.http.post<any>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/loaduserdata', null).subscribe(
        data => {
            var role = '';
            if(data.hasOwnProperty('role')) {
                role = data['role'];
            }
         
            if (data.hasOwnProperty('areas')) {
              let userAreas = data['areas'];
              var keys = Object.keys(userAreas);
              this.reportAreas = [];
             
              if(role == 'System Coordinator') {  
                  var pickup = new DropdownValues();
                  pickup.value = undefined;
                  pickup.name = "Pick an option";
                  this.reportAreas.push(pickup); 
                  var pickupAll = new DropdownValues();
                  pickupAll.value = "All"
                  pickupAll.name = "All";
                  this.reportAreas.push(pickupAll);
              
                  
                  for (let k of keys) {
                      var dv = new DropdownValues();
                      dv.value = userAreas[k];
                      dv.name = userAreas[k];
                      this.reportAreas.push(dv);
                  }
              } else if (role == 'Area supervisor' ||
                         role == 'County Supervisor' ||
                         role == 'County Worker'  ) { 
                for (let k of keys) {
                  var dv = new DropdownValues();
                  dv.value = userAreas[k];
                  dv.name = userAreas[k];
                  this.reportAreas.push(dv);
                } 
                this.reportAreaCode  = this.reportAreas[0].value;  
                console.log("Area code: " + this.reportAreaCode); 
                this.areaDisabled = true;  
              } else {
                  this.areaDisabled = true;
              }
            }

        
            if (data.hasOwnProperty('counties')) {    
              let userCounties = data['counties'];
              var keys = Object.keys(userCounties);

              if((role !== 'County Supervisor') && (role !== 'County Worker')) {
                let userCounties = data['counties'];
                var keys = Object.keys(userCounties);
                this.reportCounties = [];
                var pickup = new DropdownValues();
                pickup.value = undefined;
                pickup.name = "Pick an option";
                this.reportCounties.push(pickup);                
                var pickup = new DropdownValues();
                pickup.value = "All"
                pickup.name = "All";
                this.reportCounties.push(pickup);
                for (let k of keys) {
                    var dv = new DropdownValues();
                    dv.value = k;
                    dv.name = userCounties[k];
                    this.reportCounties.push(dv);
                }           
               } else {
        
                  this.reportCounties = [];
                  for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userCounties[k];
                        this.reportCounties.push(dv);
                  }     
                  this.reportCounty  = this.reportCounties[0].value;            
                }
              }
    
            if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
            {  
                if (data.hasOwnProperty('providers')) {
                    let userProviders = data['providers'];
                    var keys = Object.keys(userProviders);
                    this.reportProviders = [];
                    
                    var pickup = new DropdownValues();
                    pickup.value = undefined;
                    pickup.name = "Pick an option";
                    this.reportProviders.push(pickup);                     
                    
                    var pickupAll = new DropdownValues();
                    pickupAll.value = "All"
                    pickupAll.name = "All";
                    this.reportProviders.push(pickupAll);
                    for (let k of keys) {
                        var dv = new DropdownValues();
                        dv.value = k;
                        dv.name = userProviders[k];
                        this.reportProviders.push(dv);
                    }    
                }
            } else if(this.sharedData.get("roles")[0].id == 5) {
              if (data.hasOwnProperty('providers')) {
                  let userProviders = data['providers'];
                  var keys = Object.keys(userProviders);
                  this.reportProviders = [];
                  for (let k of keys) {
                      var dv = new DropdownValues();
                      dv.value = k;
                      dv.name = userProviders[k];
                      this.reportProviders.push(dv);
                  }           
                  this.reportProvider  =  this.reportProviders[0].value;
               }
               this.providerDisabled = true; 
            } else {
              if (data.hasOwnProperty('providers')) {
                let userProviders = data['providers'];
                var keys = Object.keys(userProviders);
                this.reportProviders = [];
                
                var pickup = new DropdownValues();
                pickup.value = undefined;
                pickup.name = "Pick an option";
                this.reportProviders.push(pickup);                     
                
                var pickupAll = new DropdownValues();
                pickupAll.value = "All"
                pickupAll.name = "All";
                this.reportProviders.push(pickupAll);
                for (let k of keys) {
                    var dv = new DropdownValues();
                    dv.value = k;
                    dv.name = userProviders[k];
                    this.reportProviders.push(dv);
                }    
            }
          }
          
          }, response => {
            console.log('Get call in error', response);
          }, () => {
    
          });
    }

    getReportCounties() {
        this.reportCounties = this.refTableService.getValueFromSharedDataMap("COUNTIES");
    }

    getUserActionNotifications(){
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    }

    onChange(value) {
        if (value == '1: CC') {
            this.router.navigate(["/reports/federalReports/CC"]);
        }

        if (value == '2: CR') {
            this.router.navigate(["/reports/federalReports/CR"]);
        }

        if (value == '3: ER') {
            this.router.navigate(["/reports/federalReports/ER"]);
        }

        if(value == '4: ET') {
            this.router.navigate(["/reports/employment-training-retention"]);
        }

        if(value == '5: SD') {
            this.router.navigate(["reports/monthly-snapshot-details"]);
        }
        if(value == '6: SR') {
            this.router.navigate(["reports/monthly-snapshot-rollup"]);
        }
        if(value == '7: CA') {
            this.router.navigate(["reports/component-activity"]);
        }
        if(value == '8: PC') {
          this.router.navigate(["reports/potential-candidates"]);
        }
        if(value == '9: AR') {
          this.router.navigate(["reports/aries-task"]);
        }
    }

    validDates() {
        if (this.reportBeginDate !== undefined
          && this.reportBeginDate !== null
          && this.reportEndDate !== undefined
          && this.reportEndDate !== null) {
          const startDt = new Date(this.reportBeginDate.year,
            this.reportBeginDate.month - 1,
            this.reportBeginDate.day);
          const endDt = new Date(this.reportEndDate.year,
            this.reportEndDate.month - 1,
            this.reportEndDate.day)
          const startMonth = this.reportBeginDate.month;
          const endMonth = this.reportEndDate.month;
          if (startDt > endDt) {
            this.errorEndDateField = REPSTDT_GT_REPENDDT;
            return false;
          } else {
            this.errorEndDateField = null;
          }
          const nextYear = new Date(startDt);
          nextYear.setFullYear(nextYear.getFullYear() + 1)
          if(endDt >= nextYear)
          {
            this.errorEndDateField = REPSTDT_INTERVAL_REPENDDT;
            return false;
          }
        }
    
        return true;
      }

      onChangeArea(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedAreaName = this.reportAreas[id].name;
        if(this.reportAreas[id].name !== 'All'){
          event.preventDefault();
          this.loadCountiesArea(this.reportAreas[id].name);
        } else {
          event.preventDefault();
          this.loadUserInformation();
      }
    }

    onChangeCounty(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0].trim();
        if(id !== 'All' && id !== undefined) {
         this.reportSelectedCountyName = this.reportCounties[id].name;
        } else if(id == 'All' && id !== undefined) {
            this.reportSelectedCountyName ='All';
        } else {
          this.reportSelectedCountyName = undefined;
        }
        this.errorMandatoryCounty = false;
    }


    onChangeProvider(value) {
        var valueSelected = value.split(':')
        var id = valueSelected[0];
        this.reportSelectedProviderName = this.reportProviders[id].name;
        this.errorMandatoryProvider = false;
    }

    onChangeParticipant(value) {
      this.reportSelectedParticipantName = value;
    }

    checkMandatoryParameters() {
      return this.checkMandatoryCounty() && this.checkMandatoryProvider();
    }

    checkMandatoryProvider() {
        if(( this.reportProvider !== undefined
            && this.reportProvider !== null)) {
              return true;
        } 
        this.errorMandatoryProvider = "Please select a Provider";
        return false;
        
    }

    checkMandatoryCounty() {
        if (this.reportCounty !== undefined
                && this.reportCounty !== null) {
                    return true; 
        } 
        this.errorMandatoryCounty = "Please select a County";
        return false; 
    }
    
      downloadPDFKeydown(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          this.downloadnodePDF(event);
        }
      }

      loadCountiesArea(areaName) {
      
        this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/find/', {
          name: areaName,
          type: 'RT'
        }).subscribe((val) => {
            
            // Add "Pick an Option" to all reference tables
            if (val.dataValue !== undefined && val.dataValue.EN !== undefined) {
              val.dataValue.EN.forEach((value)=>{
                if(value.activeBeginDt!==null && value.activeBeginDt!==undefined){
                  value.activeBeginDt = this.dateUtil.formatDate1(value.activeBeginDt);
                }
                if(value.activeEndDt!==null && value.activeEndDt!==undefined){
                  value.activeEndDt = this.dateUtil.formatDate1(value.activeEndDt);
                }
              })
              var staticDataMap = val.dataValue.EN;
              staticDataMap.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
              });
            
              this.reportCounties = [];
              var pickup = new DropdownValues();
              pickup.value = undefined;
              pickup.name = "Pick an option";
              this.reportCounties.push(pickup);                
              var pickup = new DropdownValues();
              pickup.value = "All"
              pickup.name = "All";
              var m = new Date();
              var dateString = m.getUTCFullYear() + "/" +
              ("0" + (m.getUTCMonth()+1)).slice(-2) + "/" +
              ("0" + m.getUTCDate()).slice(-2);
              
              this.reportCounties.push(pickup);
              for (let d of staticDataMap) {
                  var dv = new DropdownValues();
                 
                  let d1 = new Date(dateString); 
                  if(d.activeSW == 'Y') {
                    let d2 = new Date(d.activeBeginDt);
                    if(d2 <= d1) {
                      dv.value = d.value;
                      dv.name = d.name;
                      this.reportCounties.push(dv);
                    }
                  }
              }           

            }
            
          },
          response => {
            //this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
          },
          () => {
    
          });
      }

      loadParticipationTypes() {
        this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/find/', {
          name: 'WORK_PARTICIPATION',
          type: 'RT'
        }).subscribe((val) => {
            
            // Add "Pick an Option" to all reference tables
            if (val.dataValue !== undefined && val.dataValue.EN !== undefined) {
              val.dataValue.EN.forEach((value)=>{
                if(value.activeBeginDt!==null && value.activeBeginDt!==undefined){
                  value.activeBeginDt = this.dateUtil.formatDate1(value.activeBeginDt);
                }
                if(value.activeEndDt!==null && value.activeEndDt!==undefined){
                  value.activeEndDt = this.dateUtil.formatDate1(value.activeEndDt);
                }
              })
              var staticDataMap = val.dataValue.EN;
              staticDataMap.sort(function(a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
              });
            
              this.reportParticipationTypes = [];

              var pickup = new DropdownValues();
              pickup.value = "Pick an option";
              pickup.name = undefined;
              this.reportParticipationTypes.push(pickup);      
                        
              var m = new Date();
              var dateString = m.getUTCFullYear() + "/" +
              ("0" + (m.getUTCMonth()+1)).slice(-2) + "/" +
              ("0" + m.getUTCDate()).slice(-2);
              
              for (let d of staticDataMap) {
                  var dv = new DropdownValues();
                 
                  let d1 = new Date(dateString); 
                  if(d.activeSW == 'Y') {
                    let d2 = new Date(d.activeBeginDt);
                    if(d2 <= d1) {
                      dv.value = d.name;
                      dv.name = d.value;
                      this.reportParticipationTypes.push(dv);
                    }
                  }
              }           

            }
            
          },
          response => {
            //this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
          },
          () => {
    
          });
      }

      searchEmploymentTrainingData(event) {
        this.payloadEmploymentTrainingRetentionRequest = new EmploymentTrainingRetentionRequest();
          
        if(this.checkMandatoryParameters() && this.validDates() )
        {
            this.roleId = this.sharedData.get("roles")[0].id;
            //code for enable and disable
            if (this.sharedData.get("roles")[0].id == 5) {
              this.butDisabled = true;
                for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
                  this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
                }
               
                this.payloadEmploymentTrainingRetentionRequest.provider = this.reportProvider;
            
            } else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3) {
              for(let i=0; i<this.sharedData.get("userCounties").length; i++){
                this.payloadEmploymentTrainingRetentionRequest[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
              }
              this.payloadEmploymentTrainingRetentionRequest.provider=null;
              this.butDisabled = true;
              this.countyDisabled = true;
              this.countyCode = this.sharedData.get("userCounties")[0].id.serviceCounty;

            } else if(this.sharedData.get("roles")[0].id == 2) {
              this.butDisabled = true;
              for(let i=0; i<this.sharedData.get("userCounties").length; i++){
                this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
                this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
              }
              //this.componentActivitiesRequest.counties = this.countyArray;
              this.payloadEmploymentTrainingRetentionRequest.provider = null;
            }
       
    
            if (this.reportBeginDate != null) {
              let day = this.reportBeginDate.day;
              let month = this.reportBeginDate.month;
              let year = this.reportBeginDate.year;
              if (day < 10 && month < 10) {
                this.reportBeginDate = year + '/0' + month + '/0' + day;
              }
              else if (day < 10) {
                this.reportBeginDate = year + '/' + month + '/0' + day;
              }
              else if (month < 10) {
                this.reportBeginDate = year + '/0' + month + '/' + day;
              }
              else {
                this.reportBeginDate = year + '/' + month + '/' + day;
              }
    
         }
    
            if (this.reportEndDate != null) {
                let day = this.reportEndDate.day;
                let month = this.reportEndDate.month;
                let year = this.reportEndDate.year;
                this.reportEndDate = year + '/' + month + '/' + day;
                if (day < 10 && month < 10) {
                this.reportEndDate = year + '/0' + month + '/0' + day;
                }
                else if (day < 10) {
                this.reportEndDate = year + '/' + month + '/0' + day;
                }
                else if (month < 10) {
                this.reportEndDate = year + '/0' + month + '/' + day;
                }
                else {
                this.reportEndDate = year + '/' + month + '/' + day;
                }
            }
    
         
            if(this.reportCounty !== 'undefined') {
              this.payloadEmploymentTrainingRetentionRequest.county=this.reportCounty;
            }
            if(this.reportProvider !== 'undefined') {
              this.payloadEmploymentTrainingRetentionRequest.provider=this.reportProvider;
            }

            if(this.reportAreaCode !== 'undefined') {
              this.payloadEmploymentTrainingRetentionRequest.areaCode=this.reportAreaCode;
            }

            if(this.reportParticipation !== 'undefined') {
              this.payloadEmploymentTrainingRetentionRequest.participationType=this.reportParticipation;
            }
            
            this.payloadEmploymentTrainingRetentionRequest.report=this.report;
            this.payloadEmploymentTrainingRetentionRequest.reportBeginDate= this.reportBeginDate;
            this.payloadEmploymentTrainingRetentionRequest.reportEndDate= this.reportEndDate;

            this.payloadEmploymentTrainingRetentionRequest.role =  this.sharedData.get("roles")[0].name;


            this.loaderFocus = false;
            this.loaderGenerateFocus = true;
            event.srcElement.blur();
            event.preventDefault();
        
            this.loadEmploymentTraining();
        }

    }

    loadEmploymentTraining() {
      this.http.post<EmploymentTrainingRetentionRequest>(this.ServerConstants.REPORT_SERVER_API_URL+'/reportTaskSummary/employmentandtrainingretention', this.payloadEmploymentTrainingRetentionRequest).subscribe(
        (data:PyramidVO ) => {
          
          this.reportNameOutput = data.reportTitle;
          this.payloadEmploymentTrainingRetentionVO = data;
          this.employmentRetentionInput = true;
          this.pdfDocument = true;
          if (data.reportBeginDate!= null) {
            this.reportBeginDate = this.dateUtil.convertDateFromServerForreports(data.reportBeginDate);
          }

          if (data.reportEndDate!= null) {
            this.reportEndDate = this.dateUtil.convertDateFromServerForreports(data.reportEndDate);
          }
        
       
        }, response => {
          //this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
        }, () => {
  
  
        });
  
    }



    downloadnodePDF(event){
      var width = 420;
      var height = 220;
      var temp = [420, 220];
      var doc = new jsPDF("p", "mm", "a1");
      var rows = [];

      let canvas = document.createElement('canvas');
      let svg = document.getElementsByTagName('svg')[0];
      let svgWidth = svg.getAttribute('width');
      let svgHeight = svg.getAttribute('height');
      canvas.setAttribute ('width', svgWidth);
      canvas.setAttribute ('height', svgHeight);
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')
      canvg(canvas, svg.innerHTML);
      let imgData = canvas.toDataURL('image/png');
     

      if(this.reportSelectedAreaName !== undefined && this.reportSelectedAreaName !== null) {
          doc.text(15, 10, 'Report : Employment & Training Retention Report - ');
          doc.text(15, 20,  'Area : ' + this.reportSelectedAreaName
          + ' - Provider: ' + this.reportSelectedProviderName );
      } else if(this.reportSelectedCountyName !== undefined && this.reportSelectedCountyName !== null) {
          doc.text(15, 10, 'Report : Employment & Training Retention Report  - ' );
          doc.text(15, 25, 'County :'  + this.reportSelectedCountyName
          + ' - Provider: ' + this.reportSelectedProviderName );
      }
      doc.addImage(imgData, 'PNG', 15, 30, 150, 150);

      doc.save('Employment_&_Training_Retention_Report.pdf');
    
  }
}

export class DropdownValues {
    constructor(  
        public name?:string,
         public value?:string,
    ) {}
  }



// WEBPACK FOOTER //
// ./src/app/employment-training-retention/employment-training-retention.component.ts